/**
 * Client for Email-Notification MFA endpoints for WPS Studio.
 */

const getApiBase = () => {
  const base = process.env.REACT_APP_MFA_API_BASE
  if (!base) {
    throw new Error('REACT_APP_MFA_API_BASE environment variable is not defined.')
  }
  return base.replace(/\/$/, '')
}

export async function getMfaStatus(email: string): Promise<{ requireOtp: boolean }> {
  const res = await fetch(`${getApiBase()}/wps-studio/mfa-status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data.message || 'Failed to get MFA status')
  }
  const data = await res.json()
  return data.data
}

export async function sendMfaOtp(email: string): Promise<void> {
  const res = await fetch(`${getApiBase()}/wps-studio/send-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data.message || 'Failed to send OTP')
  }
}

export async function verifyMfaOtp(
  email: string,
  otp: string,
  mfaSession: string
): Promise<{ mfaSkipDays: number }> {
  const res = await fetch(`${getApiBase()}/wps-studio/verify-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code: otp, session: mfaSession })
  })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data.error || data.message || 'Invalid or expired OTP')
  }
  const data = await res.json()
  return data.data || data
}
